import { useNavigate } from 'react-router-dom-v5-compat';
import { SEGMENTATION_ENDPOINT } from 'modules/segmentation/constants';
import { SegmentationRedirect } from '../types';

/**
 *
 * hook for creating an onClick fn to redirect to segmentation w/ a provided searchQuery
 */
export const useRedirectToSegmentationWithSearchQuery = ({
  search,
  searchQuery,
  target,
  automaticallyLoadResults = true,
}: SegmentationRedirect) => {
  const navigate = useNavigate();
  return () => {
    navigate(
      {
        pathname: SEGMENTATION_ENDPOINT,
        search,
        ...(target && { target }),
      },
      { state: { searchQuery, automaticallyLoadResults } },
    );
  };
};
